export const Globals = {    
  name: 'MOLN Mobil',
  description: 'Molnstruktur self-service application.',
  bundle: 'com.molnstruktur.app',
  urls: {
    help: "https://molnstruktur.se/help",
  },
  colors: {
    brand: '#0033ff',
    alpha: '#ffffff',
    beta: '#ebebeb',
    gamma: '#212231',
    delta: '#222222',
    epsilon: '#f8f8f8',
    zeta: '#ffffff',
    eta: '#d7d7d7',
    theta: '#9b9b9b',
    iota: '#6dc98c',
    kappa: '#345736',
    lambda: '#ff3a30',
    mu: '#fc8b8b',
    nu: '#e5a051',
    xi: '#fbd343',
    omicron: '#606060',
    incoming: '#fc8b8b',
    outgoing: '#0033ff',
  }
  
};
